import React from "react";
import { PayrollWorkloadAnticipationContainer } from "../../../containers";

const PayrollWorkloadAnticipation = (props) => {
  return <PayrollWorkloadAnticipationContainer {...props} />;
};

export default PayrollWorkloadAnticipation;
